import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coming-soon-page',
  templateUrl: './coming-soon-page.component.html',
  styleUrls: ['./coming-soon-page.component.css']
})
export class ComingSoonPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
